import { observer } from 'mobx-react-lite';
import { SyntheticEvent, forwardRef, useEffect, useRef, useState } from 'react';
import { Input } from 'semantic-ui-react';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import { useStore } from '../../app/stores/store';
import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';
import { useParams } from 'react-router-dom';
import { initialPostFilteredItemDetails, PostFilteredItemDetailsTypes } from '../../app/models/metaDataConfig';

interface Props {
  tablehead: any;
  tablename: string;
  index: number;
  setPageNumber?: any;
  loader?: boolean;
  searchFuncExecution?: (event: any, data: any) => void;
  searchVal?: string;
  EmailsearchHandler?:any;
}

function SearchInputData({
  tablehead,
  tablename,
  index,
  setPageNumber,
  loader,
  searchFuncExecution,
  searchVal,
  EmailsearchHandler
}: Props) {
  const timerId = useRef<any>();
  const { id } = useParams<{ id: string }>();

  const {
    dashboardStore,
    activityStore,
    emailStore,
    receivingdeliveryStore,
    WorkLevelStore,
    userStore,
    reportStore,
    commonStore,
    PivotStore,
    CRMStore,
    metaDataStore
  } = useStore();
  const { dashboard } = dashboardStore;

  const [date, setDate] = useState<string>('');
  const [isDateField, setIsDateField] = useState<boolean>(false);

  useEffect(() => {
    if (
      tablehead === 'movementdate' ||
      tablehead === 'itemCreatedAt' ||
      tablehead === 'status_Time' ||
      tablehead === 'projectEndDate' ||
      tablehead === 'movement_Time' ||
      tablehead === 'projectStartDate' ||
      tablehead === 'receivingdate' ||
      tablehead === 'maintenance' ||
      tablehead === 'dateRequestRaised' ||
      tablehead === 'dateOfDelivery' ||
      tablehead === 'dateOfReturn' ||
      tablehead === 'dateOrderRegistered' ||
      tablehead === 'inwardDateTime' ||
      tablehead === 'date' ||
      tablehead === 'dateTime'
    ) {
      // const newDate = PivotStore.dateFormat(date);
      setIsDateField(true);
    }
    // eslint-disable-next-line
  }, [tablehead]);

  // const inputRef = useCallback((node) => {
  //   const focusHandler = () => {
  //     if (
  //       tablehead === "movementdate" ||
  //       tablehead === "itemCreatedAt" ||
  //       tablehead === "status_Time" ||
  //       tablehead === "projectEndDate" ||
  //       tablehead === "movement_Time" ||
  //       tablehead === "projectStartDate" ||
  //       tablehead === "receivingdate" ||
  //       tablehead === "maintenance" ||
  //       tablehead === "dateRequestRaised" ||
  //       tablehead === "dateOfDelivery" ||
  //       tablehead === "dateOfReturn" ||
  //       tablehead === "dateOrderRegistered" ||
  //       tablehead === "inwardDateTime" ||
  //       tablehead === "date" ||
  //       tablehead === "dateTime"
  //     ) {
  //       setIsShowToolTip(true);
  //     } else {
  //       setIsShowToolTip(false);
  //     }
  //   };

  //   const blurHandler = () => {
  //     setIsShowToolTip(false);
  //   };

  //   node?.childNodes[0]?.addEventListener("focus", focusHandler);
  //   node?.childNodes[0]?.addEventListener("blur", blurHandler);
  //   return () => {
  //     node?.childNodes[0]?.removeEventListener("focus", focusHandler);
  //     node?.childNodes[0]?.removeEventListener("blur", blurHandler);
  //   };
  //   // eslint-disable-next-line
  // }, []);

  const searchData = async (newArr: any) => {
    function commonSearch(name: string) {
      // if search is empty --->>>>
      if (
        Object.values(dashboardStore.dashboard.searchfilterparams).every(
          (o) => o === '',
        )
      ) {
        let ReportTableChosen: any = localStorage.getItem(tablename);
        let chosenArr = ReportTableChosen.split(',');
        chosenArr.push('id');
        const lower = chosenArr.map((element: any) => {
          return element.toLowerCase();
        });
        return {
          value: lower,
          type: 'empty',
        };
      } else {
        // if search is not empty --->>>> and Header table contains  many value
        let ReportTableChosen = localStorage.getItem(name);
        if (ReportTableChosen?.split(',')) {
          let ReportTableChosenId = ReportTableChosen?.split(',');
          ReportTableChosenId.push('id');
          const lower = ReportTableChosenId.map((element) => {
            return element.toLowerCase();
          });
          return {
            value: lower,
            type: 'manySearchValues',
          };
        } else {
          // if search is not empty --->>>> and Header table contains only one value
          let ReportTableChosenId = [ReportTableChosen];
          ReportTableChosenId.push('id');
          const lower = ReportTableChosenId.map((element: any) => {
            return element.toLowerCase();
          });
          return {
            value: lower,
            type: 'singleSearchValue',
          };
        }
      }
    }

    dashboardStore.dashboard.orderData = '';
    //sort order Icon
    dashboardStore.dashboard.orderIcon = '';
    dashboardStore.dashboard.orderName = '';
    let newObj: any = Object.fromEntries(
      Object.entries(newArr).map(([k, v]) => [k.toLowerCase(), v]),
    );

    if (!Object.keys(newObj)?.length) {
      newObj = null;
    }

    // if (
    //   (tablename === "ReportsTable")
    // ) {
    //   dashboard.setTagTablePageNumber = 1;
    //   activityStore.searchListItems(newObj, 1, 5);
    //   // eslint-disable-next-line
    // }
    if (
      userStore.user?.customerName !== 'LVPCMS' && !commonStore.hfcCustomerChanges &&
      (tablename === 'AssetTable' || tablename === 'InventoryReportsTable')
    ) {
      dashboard.setTagTablePageNumber = 1;
      activityStore.searchListItems(newObj, 1, 5);
      // eslint-disable-next-line
    }
    if(commonStore.hfcCustomerChanges && tablename === 'AssetTable' ){
      dashboardStore.setReportsPageNum(1);
      let newArr: any[] = [];
      if(newObj){
        if (Object.keys(newObj).length > 0) {
          Object.entries(newObj)?.forEach(([key, value]) => {
            newArr.push({
              "header": key,
              "searchValue": value
            });
          });
        }
      }
      else {
        newArr = [];
      }
      activityStore.HFCloadActivitiesPagination(1, userStore.user!.id,5, newArr)
    }
    if(commonStore.hfcCustomerChanges && tablename === 'HFCMoveToVault' ){
      dashboardStore.setReportsPageNum(1);
      let newArr: any[] = [];
      if(newObj){
        if (Object.keys(newObj).length > 0) {
          Object.entries(newObj)?.forEach(([key, value]) => {
            newArr.push({
              "header": key,
              "searchValue": value
            });
          });
        }
      }
      else {
        newArr = [];
      }
      activityStore.HFCVaultloadActivitiesPagination(1, userStore.user!.id,5, newArr)
    }
    if(tablename === 'HFCShipper' && dashboardStore.dashboard.valueForL3Orders === ""){
      dashboardStore.setReportsPageNum(1);
      let newArr: any[] = [];
      if(newObj){
        if (Object.keys(newObj).length > 0) {
          Object.entries(newObj)?.forEach(([key, value]) => {
            newArr.push({
              "header": key,
              "searchValue": value
            });
          });
        }
      }
      else {
        newArr = [];
      }
      activityStore.HFCDeliveryRequest(1, userStore.user!.id,5, newArr)
    }
    if(tablename === 'HFCShipper' && dashboardStore.dashboard.valueForL3Orders === "Shipper"){
      dashboardStore.setReportsPageNum(1);
      let newArr: any[] = [];
      if(newObj){
        if (Object.keys(newObj).length > 0) {
          Object.entries(newObj)?.forEach(([key, value]) => {
            newArr.push({
              "header": key,
              "searchValue": value
            });
          });
        }
      }
      else {
        newArr = [];
      }
      activityStore.HFCShipperloadActivitiesPagination(1, userStore.user!.id,5, newArr)
    }
    if(tablename === 'HFCShipper' && dashboardStore.dashboard.valueForL3Orders === "Pull"){
      dashboardStore.setReportsPageNum(1);
      let newArr: any[] = [];
      if(newObj){
        if (Object.keys(newObj).length > 0) {
          Object.entries(newObj)?.forEach(([key, value]) => {
            newArr.push({
              "header": key,
              "searchValue": value
            });
          });
        }
      }
      else {
        newArr = [];
      }
      activityStore.HFCPullloadActivitiesPagination(1, userStore.user!.id,5, newArr)
    }
    if(tablename === 'HFCShipper' && dashboardStore.dashboard.valueForL3Orders === "Shipping Prep"){
      dashboardStore.setReportsPageNum(1);
      let newArr: any[] = [];
      if(newObj){
        if (Object.keys(newObj).length > 0) {
          Object.entries(newObj)?.forEach(([key, value]) => {
            newArr.push({
              "header": key,
              "searchValue": value
            });
          });
        }
      }
      else {
        newArr = [];
      }
      activityStore.HFCShippingPreploadActivitiesPagination(1, userStore.user!.id,5, newArr)
    }

    if(tablename === 'HFCShipper' && dashboardStore.dashboard.valueForL3Orders === "Shipping"){
      dashboardStore.setReportsPageNum(1);
      let newArr: any[] = [];
      if(newObj){
        if (Object.keys(newObj).length > 0) {
          Object.entries(newObj)?.forEach(([key, value]) => {
            newArr.push({
              "header": key,
              "searchValue": value
            });
          });
        }
      }
      else {
        newArr = [];
      }
      activityStore.HFCShippingdeliveryloadActivitiesPagination(1, userStore.user!.id,5, newArr)
    }
    if(tablename === 'HFCShipper' && dashboardStore.dashboard.valueForL3Orders === "Receiving"){
      dashboardStore.setReportsPageNum(1);
      let newArr: any[] = [];
      if(newObj){
        if (Object.keys(newObj).length > 0) {
          Object.entries(newObj)?.forEach(([key, value]) => {
            newArr.push({
              "header": key,
              "searchValue": value
            });
          });
        }
      }
      else {
        newArr = [];
      }
      activityStore.HFCReceivingloadActivitiesPagination(1, userStore.user!.id,5, newArr)
    }
    if(tablename === 'HFCShipper' && dashboardStore.dashboard.valueForL3Orders === "Assign Task to Personnal"){
      dashboardStore.setReportsPageNum(1);
      let newArr: any[] = [];
      if(newObj){
        if (Object.keys(newObj).length > 0) {
          Object.entries(newObj)?.forEach(([key, value]) => {
            newArr.push({
              "header": key,
              "searchValue": value
            });
          });
        }
      }
      else {
        newArr = [];
      }
      activityStore.HFCAssignTaskloadActivitiesPagination(1, userStore.user!.id,5, newArr)
    }
    if(tablename === 'HFCShipper' && dashboardStore.dashboard.valueForL3Orders === "Services"){
      dashboardStore.setReportsPageNum(1);
      let newArr: any[] = [];
      if(newObj){
        if (Object.keys(newObj).length > 0) {
          Object.entries(newObj)?.forEach(([key, value]) => {
            newArr.push({
              "header": key,
              "searchValue": value
            });
          });
        }
      }
      else {
        newArr = [];
      }
      activityStore.HFCServiceloadActivitiesPagination(dashboardStore.dashboard.valueForL4Orders,1, userStore.user!.id,5, newArr)
    }
    if (tablename === 'QuickScan') {
      dashboard.setTagTablePageNumber = 1;
      activityStore.searchListItems(newObj, 1, 20);
    }
    if (tablename === 'AllocateUser') {
      dashboard.setTagTablePageNumber = 1;
      activityStore.searchListItems(newObj, 1, 10);
      // eslint-disable-next-line
    }

    if (
      userStore.user?.customerName === 'LVPCMS' &&
      tablename === 'AssetTable'
    ) {
      if (Object.keys(newObj)?.length) {
        activityStore.searchListItems(newObj, 1, 5);
        } else {
          activityStore.searchListItemsLVPMSCount();
        }
    }
      if(tablename === 'prodPlanTable' && userStore?.user?.customerName === 'NFAIReport'){
    dashboard.setTagTablePageNumber = 1;
     let payload: PostFilteredItemDetailsTypes;

    payload = {
      ...initialPostFilteredItemDetails,
      title: newObj?.title || '',
      currentTask: activityStore.prodTask || '',
      currentSubtask: activityStore.prodSubTasks || '',
      status: newObj?.status || '',
      Previoustask: newObj?.previoustask || newObj?.previousTask || '',
      PreviousSubtask: newObj?.previoussubtask || newObj?.previousSubtask || '',
    };
    activityStore.NFAIRestorationProductionPlanningSearch(payload);
   }
   if(tablename === 'NFAIRestorationDashboard'  && userStore?.user?.customerName === 'NFAIReport'){
    dashboard.setTagTablePageNumber = 1;  
    const payload:PostFilteredItemDetailsTypes = {
      ...initialPostFilteredItemDetails,
      title: newObj?.title || '',
      currentTask: newObj?.current_task || '',
      currentSubtask: newObj?.current_subtask || '',
      status: newObj?.status || '',
      Previoustask: newObj?.previoustask || newObj?.previousTask || '',
      PreviousSubtask: newObj?.previoussubtask || newObj?.previousSubtask || '',
    }
    metaDataStore.PostFilteredItemDetailsHandler(payload);
   }
    if (
      userStore.user?.customerName === 'LVPCMS' &&
      (tablename === 'prodPlanTable' || tablename === 'InventoryReportsTable')
    ) {
      activityStore.searchListFF(1, newObj);
    }
    if (
      userStore.user?.customerName === 'LVPCMS' &&
      tablename === 'FilmFestivalReport'
    ) {
      reportStore.searchListFF(1, newObj);
    }
    if (tablename === 'EmailTable') {
      emailStore.emailMessageSearch(newObj, 1);
    }
    if (tablename === 'ReceivingTable') {
      dashboard.setTagTablePageNumber = 1;
      receivingdeliveryStore.searchListReceiving(1, newObj);
    }
    if (tablename === 'prodPlanTable' && userStore?.user?.customerName !== 'NFAIReport') {
      let destructData = dashboardStore.dashboard;
      activityStore.searchProductionPlanning(
        destructData.setProductionType,
        destructData.setProductionTask,
        newObj,
        1,
      );
    }
    if (tablename === 'TagTable') {
      dashboard.setTagTablePageNumber = 1;
      activityStore.searchListTag(1, newObj);
    }
    if (tablename === 'CreateOrderTable') {
      dashboard.setTagTablePageNumber = 1;
      activityStore.searchListCR(1, newObj);
    }

    if (tablename === 'ReportsTable' || tablename === 'SmartTracker') {
      let result = commonSearch(
        tablename === 'SmartTracker' ? 'SmartTracker' : 'ReportsTable',
      );
      switch (result.type) {
        case 'empty':
          reportStore.loadReportPagination(1, result.value, tablename);
          dashboardStore.updateCountOrderMenu(userStore.user!.id);
          break;
        case 'manySearchValues':
        case 'singleSearchValue':
          reportStore.searchMetaDataReport(1, newObj, result.value);
          break;
      }
      if (userStore.user?.customerName === 'LVPCMS') {
        activityStore.searchListItemsLVPMSCount();
      }
    }
    if (tablename === 'viewHistoryTable') {
      activityStore.isViewHistoryLoading = true;
      activityStore.viewHistorySearch(id || '', newObj, 1, 5);
      activityStore.historyPageNumber = 1;
    }
    if (tablename === 'viewTemplateTable') {
      activityStore.viewTemplatePageNumber = 1;
      activityStore.isViewTemplateLoading = true;
      activityStore.viewTemplateSearch(id || '', newObj, 1, 5);
    }
    if (
      tablename === 'NewAssetAdded' ||
      tablename === 'DigitalizationPriority' ||
      tablename === 'AssetsCleaned' ||
      tablename === 'CurrentMonthAssetCANMovement' ||
      tablename === 'PendingReturnsFromBorrowers' ||
      tablename === 'AssetsScheduledForCleaning'
    ) {
      activityStore.inventoryReportsFetchTableDetails(newObj, 1, tablename);
    }
    if (
      tablename === 'Received' ||
      tablename === 'WaitingforApproval' ||
      tablename === 'Approved' ||
      tablename === 'InProgress' ||
      tablename === 'Ready' ||
      tablename === 'Delivered' ||
      tablename === 'Returned'
    ) {
      activityStore.OrdersReportsFetchTableDetails(newObj, 1, tablename);
    }
    if (
      tablename === 'Verify' ||
      tablename === 'Approve' ||
      tablename === 'PickerAssign' ||
      tablename === 'MoveToVault'
    ) {
      activityStore.inwardFetchTableDetails(newObj, 1, tablename);
    }
    if (
      tablename === 'Unvault' ||
      tablename === 'VerifyOutward' ||
      tablename === 'ApproveOutward' ||
      tablename === 'AssignPickerOutward' ||
      tablename === 'Move' ||
      tablename === 'Package' ||
      tablename === 'Billing'
    ) {
      activityStore.outwardFetchTableDetails(newObj, 1, tablename);
    }
    if (tablename === 'TagOrder') {
      activityStore.tagOrderFetchTableDetails(newObj, 1, tablename);
    }
    if (tablename === 'WorkLevelTable') {
      WorkLevelStore.viewItemGroupSearchDetails(newObj, 1);
    }
    if (tablename === 'AlertsTable') {
      emailStore.emailAlertSearch(newObj, 1);
    }
    if(tablename === 'ReadMail'){
      EmailsearchHandler(newObj,1,'ReadMail')
    }
   if(tablename === 'UnreadMail'){
    EmailsearchHandler(newObj,1,'UnreadMail')
   }
   if(tablename === 'IT Asset List'){
    CRMStore.handleInventorySearch(1,JSON.stringify(newObj));
    CRMStore.itAssetTableDetails.pageNumber = 1;
   }
   if(tablename === 'CrmAssetTrack'){
    CRMStore.handleCrmAssetSearch(newObj);
   }
  };

  const searchFunc = (e: SyntheticEvent, data: any) => {
    setPageNumber?.(1);
    let name = data.name || '';
    let newArr: any;
    if (!data.value?.length) {
      delete dashboardStore.dashboard.searchfilterparams[name];
      newArr = dashboardStore.dashboard.searchfilterparams;
    } else {
      newArr = {
        ...dashboardStore.dashboard.searchfilterparams,
        [name]: data.value,
      };
    }
    dashboardStore.setFocusState(name);
    dashboardStore.setFilterData(newArr);
    clearTimeout(timerId.current);

    timerId.current = setTimeout(() => {
      searchData(newArr);
    }, 2000);
  };

  const valueFunction = (d: any): any[] => {
    const keyvals = Object.fromEntries(
      Object.entries(dashboardStore.dashboard.searchfilterparams).filter(
        ([key]) => key === d,
      ),
    );
    return Object.values(keyvals);
  };
  const keyFunction = (d: any) => {
    return dashboardStore.dashboard.focusState === d ? true : false;
    // const keyvals = Object.fromEntries(Object.entries(dashboardStore.dashboard.searchfilterparams).filter(([key]) => key===d));
    // return Object.keys(keyvals).includes(d)?true:false
  };

  const dateChange = (date: string, tablehead: string) => {
    dashboardStore.dashboard.dateSearchCleared[tablehead] = true;
    const newDate = PivotStore.dateFormat(date);
    setDate(newDate);
    if (searchFuncExecution) {
      searchFuncExecution('', newDate);
    } else {
      setPageNumber?.(1);
      let name = tablehead;
      let newArr: any;
      if (newDate === 'NaN-NaN-NaN') {
        delete dashboardStore.dashboard.searchfilterparams[name];
        newArr = dashboardStore.dashboard.searchfilterparams;
      } else {
        newArr = {
          ...dashboardStore.dashboard.searchfilterparams,
          [name]: newDate,
        };
      }
      dashboardStore.setFocusState(name);
      dashboardStore.setFilterData(newArr);
      clearTimeout(timerId.current);

      timerId.current = setTimeout(() => {
        searchData(newArr);
      }, 2000);
    }
  };

  const handleClear = () => {
    dateChange('', tablehead);
    setDate('');
    dashboardStore.dashboard.dateSearchCleared[tablehead] = false;
  };

  const DateCustomInput = forwardRef(
    ({ value, onClick, onChange }: any, ref: any) => (
      <>
        <input
          value={value}
          // className="date-picker-style m0"
          ref={ref}
          onClick={onClick}
          onChange={onChange}
          placeholder={
            (userLanguage[0].Dashboard?.DST01 as any)?.[
              `${commonStore.language.key}`
            ]
          } //"Search..."
          style={{
            opacity: 0.5,
            fontFamily: "Lato, 'Helvetica Neue', Arial, Helvetica, sans-serif",
          }}
          // autoFocus={keyFunction(tablehead)}
        ></input>
        {/* {
          !loader ? <i className="search icon grey"></i> : null
        } */}
        {dashboardStore.dashboard.dateSearchCleared[tablehead] ? (
          <i
            className="close icon grey"
            onClick={handleClear}
            style={{ opacity: 0.5 }}
          ></i>
        ) : (
          <i className="search icon grey" style={{ opacity: 0.5 }}></i>
        )}
      </>
      // <Input
      //   value={value ? value : valueFunction(tablehead)}
      //   ref={ref}
      //   onClick={onClick}
      //   onChange={onChange}
      //   placeholder={
      //     (userLanguage[0].Dashboard?.DST01 as any)?.[
      //       `${commonStore.language.key}`
      //     ]
      //   } //"Search..."
      //   loading={loader}
      //   icon={!loader ? "search" : ""}
      // />
    ),
  );

  return (
    // <div className={isShowToolTip ? "searchInputTooplTip" : ""}></div>
    <div>
      {/* <Ref innerRef={inputRef}> */}
      {isDateField ? (
        <div className="date-search">
          <DatePicker
            onChange={(date: any) => dateChange(date, tablehead)}
            customInput={<DateCustomInput />}
            selected={
              !date && valueFunction(tablehead)[0]
                ? new Date(valueFunction(tablehead)[0])
                : null
            }
            value={
              !dashboardStore.dashboard.dateSearchCleared[tablehead]
                ? date
                : valueFunction(tablehead)[0]
            }
            showMonthDropdown
            showYearDropdown
          />
        </div>
      ) : (
        <Input
          autoComplete="true"
          style={{ minWidth: '200px' }}
          value={searchVal !== undefined ? searchVal : valueFunction(tablehead)}
          name={tablehead}
          key={index}
          fluid
          // loading={!loader}
          icon={'search'}
          autoFocus={keyFunction(tablehead)}
          placeholder={
            (userLanguage[0].Dashboard?.DST01 as any)?.[
              `${commonStore.language.key}`
            ]
          } //"Search..."
          //Table: Dashboard Inventory, Verify, Inventory Reports, View Item Group
          onChange={searchFuncExecution ? searchFuncExecution : searchFunc}
        />
      )}

      {/* </Ref> */}
    </div>
  );
}

export default observer(SearchInputData);
